import type { Obligatoriedad } from "@/lib/informes";

/**
 * Lo que el usuario eligió para cada documento de una pestaña.
 *
 * La AUSENCIA de entrada significa OBLIGATORIO (decisión de producto del
 * 29-09-2026): no existe "Sin definir". Es el mismo criterio que el backend,
 * donde la ausencia de fila es Obligatorio; se resuelve en
 * {@link obligatoriedadDe}, el único lugar que conoce el valor por defecto.
 *
 * Vive en su propio módulo y no junto al componente porque un archivo que
 * exporta un componente Y otras cosas rompe el fast refresh de Vite.
 */
export type DefinicionDeDocumentos = Record<number, Obligatoriedad | undefined>;

/** Arma el estado inicial de la pestaña desde lo ya guardado en el informe. */
export function definicionDesdeInforme(
  guardados: { documento_tipo_id: number; obligatoriedad: Obligatoriedad }[] | undefined,
): DefinicionDeDocumentos {
  return Object.fromEntries(
    (guardados ?? []).map((d) => [d.documento_tipo_id, d.obligatoriedad]),
  );
}

/** La obligatoriedad de un documento: lo elegido, u Obligatorio si nadie eligió. */
export function obligatoriedadDe(definicion: DefinicionDeDocumentos, id: number): Obligatoriedad {
  return definicion[id] ?? "obligatorio";
}
